import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from './assets/locales/en/translation.json'
import translationTA from './assets/locales/ta/translation.json'


const fallbackLng = ["en"];
const availableLanguages = ["en", "ta"];

const resources = {
  en: {
    translation: translationEN
  },
  ta: {
    translation: translationTA
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,

    detection: {
      checkWhitelist: true
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
